<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span class="bind">用户列表</span>
            <div class="add_main_channel jm-fr">
              <el-button icon="el-icon-plus" type="primary" @click="handleAdd">
                添加管理员
              </el-button>
              <el-button icon="el-icon-delete" type="success" :disabled="isClearing" @click="handleClearCache">
                {{ isClearing ? '正在清理 ...' : '清理系统缓存' }}
              </el-button>
            </div>
          </div>
          <div class="power-left-wrap">
            <!-- <div class="title-area"><span>部门列表</span></div> -->
            <!-- <div class="left-search-area">
                <el-input
                  placeholder="请输入内容"
                  prefix-icon="el-icon-search">
                </el-input>
              </div> -->
            <el-tree
              :data="deptTreeData"
              node-key="id"
              default-expand-all
              highlight-current
              ref="departmentTree"
              @check-change="treeHandleClick"
              @node-click="treeNodeClick"
              :expand-on-click-node="false">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span v-if="data.id === -1" style="color:blue">
                  {{ data.label }} <small style="color:grey">({{ data.count }})</small>
                </span>
                <span v-else>
                  <div :title="`部门： ${data.label}\n编号： ${data.id}\n人数： ${data.count}`">
                    {{ data.label }} <small style="color:grey">({{ data.count }})</small>
                  </div>
                </span>
                <span>
                  <el-button
                    v-if="data.id > 0"
                    type="button"
                    size="mini"
                    icon="el-icon-edit"
                    title="编辑"
                    @click="() => editTree(data)">
                  </el-button>
                  <el-button
                    v-if="data.id > -1"
                    type="text"
                    size="mini"
                    icon="el-icon-plus"
                    title="新增"
                    @click="() => appendTree(data)">
                  </el-button>
                  <el-button
                    v-if="data.id > 0"
                    type="text"
                    size="mini"
                    icon="el-icon-delete"
                    title="删除"
                    @click="() => removeTree(node, data)">
                  </el-button>
                </span>
              </span>
            </el-tree>
          </div>
          <div class="power-right-wrap">
            <el-form
              :inline="true"
              :model="searchData"
              class="adminSearch">
              <el-form-item>
                <el-select
                  v-model="searchData.department"
                  placeholder="搜索部门"
                  size="small"
                  @change="onSearch"
                  filterable
                  clearable>
                  <el-option label="所有部门" :key="-2" :value="-2"></el-option>
                  <el-option
                    :label="depart.name"
                    :value="depart.id"
                    v-for="depart in deptListData"
                    :key="depart.id"/>
                  <el-option label="未分配部门" :key="-1" :value="-1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select
                  v-model="searchData.role_id"
                  placeholder="搜索角色"
                  size="small"
                  @change="onSearch"
                  filterable
                  clearable>
                  <el-option
                    :label="role.name"
                    :value="role.rolename"
                    v-for="role in rolesData"
                    :key="role.rolename"/>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="searchData.userid"
                  placeholder="用户ID"
                  size="small"
                  clearable />
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="searchData.username"
                  placeholder="用户名"
                  size="small"
                  clearable />
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="searchData.truename"
                  placeholder="真实姓名"
                  size="small"
                  clearable />
              </el-form-item>
              <el-form-item>
                <el-checkbox
                  v-model="searchData.isOnline"
                  size="small">在线
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-checkbox
                  v-model="searchData.isCancellation"
                  size="small">注销
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-checkbox
                  v-model="searchData.isTestUser"
                  size="small">测试
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="onSearch"
                  size="small"
                  class="onSearch">查询</el-button>
              </el-form-item>
              <el-form-item >

              </el-form-item>
            </el-form>
            <jm-tableList
              url="/index/power/user"
              :refresh.sync="refresh"
              :search-data="searchData"
              :page-size="20"
              class="adminList">
              <el-table-column slot="username" label="账号名">
                <template slot-scope="scope">
                  <el-tag size="small" v-if="scope.row.testkey" type="warning">测</el-tag>
                  <a href="javascript:void(0)" :style="scope.row.testkey ? 'color:brown' : 'color:blue'" @click="handleEdit(scope)">
                    {{ scope.row.username }}
                  </a>
                </template>
              </el-table-column>
              <el-table-column slot="department" label="所属部门">
                <template slot-scope="scope">
                  {{ scope.row.department }}
                  <el-tag size="small" v-if="scope.row.is_depthead" type="success">部门主管</el-tag>
                </template>
              </el-table-column>
              <el-table-column slot="is_online" label="是否在线">
                <template slot-scope="scope">
                  <el-tag size="small" :type="scope.row.is_online == '在线' ? 'success' : 'info'">
                    {{ scope.row.is_online }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column slot="lastColumn" label="操作" width="180" align="center">
                <template slot-scope="scope">
                  <div class="btns" v-permission="[1]">
                    <el-popover ref="changePassword" placement="left" width="230" trigger="hover">
                      确定重置该账号密码？ <el-button type="warning" size="mini" @click="handleReset(scope)">重置</el-button>
                    </el-popover>
                    <el-popover ref="confirmReset" placement="left" width="230" trigger="hover">
                      确定注销该账号？ <el-button type="danger" size="mini" @click="handleCancel(scope)">注销</el-button>
                    </el-popover>

                    <el-button type="warning" icon="el-icon-view" title="重置密码" v-popover:changePassword>
                      <!-- 改密 -->
                    </el-button>
                    <el-button type="primary" icon="el-icon-edit" title="编辑" @click="handleEdit(scope)">
                      <!-- 编辑 -->
                    </el-button>
                    <el-button type="danger" icon="el-icon-delete" title="注销账号" v-popover:confirmReset>
                      <!-- 注销 -->
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>

    <!--组织架构编辑弹窗 start-->
    <el-dialog :title="treeEditForm.id ? '编辑部门' : '新增部门'" :visible.sync="dialogFormVisible">
      <el-form :model="treeEditForm" v-loading="loading">
        <el-form-item label="所属企业" label-width="95px">
          <span>大连拓中教育科技股份有限公司</span>
        </el-form-item>
        <el-form-item label="上级部门" label-width="95px">
          <el-select v-model="treeEditForm.pid" placeholder="请选择">
            <el-option :value="0" :key="0" label="--最顶级--">
            </el-option>
            <el-option
              v-for="item in deptListData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门名称" label-width="95px">
          <el-input v-model="treeEditForm.department" autocomplete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门编号" label-width="95px">
          <el-input v-model="treeEditForm.department_no" autocomplete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门介绍" label-width="95px">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入部门介绍"
            v-model="treeEditForm.department_desc">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-show="!loading">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="editSave">保存</el-button>
      </div>
    </el-dialog>
    <!--组织架构编辑弹窗 end-->
  </div>
</template>

<script>
import jmTableList from '@/components/data/tableList';
import { messageBox } from '@/utils/messagebox';

export default {
  components: { jmTableList },
  data() {
    return {
      isClearing: false,
      loading: false,
      refresh: false,
      searchData: {
        userid: '', // 用户 ID
        username: '', // 用户名
        truename: '', // 真实姓名
        role_id: '', // 角色
        department: '', // 部门
        isOnline: false, // 是否在线
        isCancellation: false, // 是否注销
        isTestUser: false, // 是否测试账户
        withDepartmentTree: true, // 是否依据部门树展示全部上级用户
      },
      rolesData: [],
      deptListData: [],
      dialogFormVisible: false,
      treeEditForm: {
        id: 0,
        pid: 0,
        department: '',
        department_no: '',
        department_desc: ''
      },
      treeId: 1000,
      checkedTreeId: 0,
      deptTreeData: []
    };
  },
  methods: {
    fetchData() {
      this.$http._get({
        url: '/index/power/userInterface'
      })
        .then((data) => {
          this.rolesData = data.data.rolers;
          this.deptListData = data.data.department;
          this.deptTreeData = data.data.departmentTree;
        });
    },
    handleAdd() {
      const { href } = this.$router.resolve({ name: 'adminEdit' });
      window.open(href, '_blank');
    },
    handleEdit(scope) { // 编辑
      const { href } = this.$router.resolve({
        name: 'adminEdit',
        params: { id: scope.row.userid }
      });
      window.open(href, '_blank');
    },
    handleReset(scope) { // 重置密码
      this.$http._post({
        url: '/index/power/userPass',
        data: { userid: scope.row.userid }
      })
        .then((data) => {
          if (data.result === 0) {
            let message = data.msg
              .replace('“', '“<strong style="color:red">')
              .replace('”', '</strong>”');
            this.$alert(message, '密码重置', {
              dangerouslyUseHTMLString: true
            });
          } else {
            this.$message({ message: data.msg, type: 'error' });
          }
          this.reset = false;
        });
    },
    handleCancel(scope) { // 注销账号
      this.$http._post({
        url: '/index/power/userCancel',
        data: { userid: scope.row.userid }
      })
        .then((data) => {
          this.$message({ message: data.msg, type: data.result !== 0 ? 'error' : 'success' });
          this.reset = false;
        });
    },
    handleCommand(command) {
      let userid = command.split('-')[0];
      let hash = command.split('-')[1];

      this.$router.push({
        name: 'adminExtend',
        params: { id: userid },
        hash: `#${hash}`
      });
    },
    onSearch() {
      this.refresh = true;
    },
    // 打开编辑节点弹窗
    editTree(data) {
      this.treeEditForm.id = data.id;
      this.dialogFormVisible = true;
      this.loading = true;
      this.$http._get({
        url: `/index/power/department?id=${data.id}`
      })
        .then((data) => {
          this.loading = false;
          this.treeEditForm = data.data;
        });
    },
    // 添加子节点
    appendTree(data) {
      this.dialogFormVisible = true;
      this.treeEditForm = {
        id: 0,
        pid: data.id,
        department: '',
        department_no: '',
        department_desc: ''
      };
    },
    // 删除子节点
    removeTree(node, data) {
      messageBox.msgBox({ message: `确认要删除"${node.label}"部门吗？` }).then(() => {
        this.$http._post({
          url: '/index/power/departmentDel',
          data: { id: data.id }
        })
          .then((data) => {
            this.$message({ message: data.msg, type: data.result !== 0 ? 'error' : 'success' });
            if (data.result === 0) {
              this.fetchData();
            }
          });
      }).catch(() => {
      });
    },
    treeHandleClick(data, checked) { // data, checked, node
      if (checked === true) {
        this.checkedTreeId = data.id;
        this.$refs.departmentTree.setCheckedNodes([data]);
      }
    },
    treeNodeClick(data) { // data, checked, node
      if (data.id === 0) {
        this.searchData.department = -2;
      } else {
        this.searchData.department = data.id;
      }
      this.onSearch();
      this.checkedTreeId = data.id;
      this.$refs.departmentTree.setCheckedNodes([data]);
    },
    // 编辑部门弹窗保存
    editSave() {
      this.$http._post({
        url: '/index/power/departmentEdit',
        data: this.treeEditForm
      })
        .then((data) => {
          this.$message({ message: data.msg, type: data.result !== 0 ? 'error' : 'success' });
          if (data.result === 0) {
            this.fetchData();
            this.dialogFormVisible = false;
          }
        });
    },
    handleClearCache() {
      this.$confirm('确定要清理系统缓存吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (!this.isClearing) {
          this.isClearing = true;
          this.$http._get({
            url: '/index/api_base/clearCache'
          }).then(() => {
            this.isClearing = false;
            this.$message.success('系统缓存清理完毕');
          });
        }
      });
    },
  },
  watch: {},
  beforeMount() {
    this.fetchData();
  },
};
</script>

<style scoped>
  .adminSearch {
    padding: .5em 0;
  }
  .adminSearch /deep/ .el-form-item {
    margin-bottom: 10px;
  }
  .onSearch {
    padding-right: 2.25em;
    padding-left: 2.25em;
  }
  .btns  /deep/ .el-button {
    padding: 4px;
    margin: 0 3px 0 0;
  }
  .power-left-wrap{
    float: left;
    width: 290px;
    height: 100%;
  }
  .power-left-wrap .title-area{
    height: 52px;
    line-height: 51px;
    padding: 0 20px;
    font-weight: bold;
    font-size: 20px;
    border-bottom: 1px solid #f0f0f0;
    border-top: 1px solid #f0f0f0;
  }
  .power-left-wrap .left-search-area{
    padding-right: 10px;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .power-right-wrap{
    margin-left: 290px;
    padding-left: 10px;
    border-left: 1px solid #f0f0f0;
  }
  .custom-tree-node{
    width: 100%;
  }
  .custom-tree-node::after{
    clear: both;
    display: block;
    content: "";
  }
  .custom-tree-node > span{
    line-height: 26px;
    float: left;
    max-width: 55%
  }
  .custom-tree-node > span > div{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .custom-tree-node > span:nth-of-type(2){
    float: right;
    padding-right: 10px;
    font-size: 0;
    display: none;
    height: 26px;
    overflow: hidden;
  }
  .custom-tree-node > span:nth-of-type(2) .el-button{
    padding: 0;
  }
  .custom-tree-node:hover > span:nth-of-type(2){
    display: block;
  }
  .custom-tree-node .el-button{
    line-height: 26px;
    font-size: 14px;
    height: 26px;
    background: none;
    border: none;
    margin: 0 4px;
    color: #aaa;
  }
  .custom-tree-node .el-button:hover{
    color: #409EFF;
  }
  .custom-tree-node .el-button img{
    display: inline-block;
    vertical-align: middle;
    width: 14px;
  }
</style>
